import React, { useEffect, useState } from "react";
import { ClinicArrow, ClinicLocationIcon, LocationPetIcon } from "../Icons";
import { Button } from "@mui/material";
import { locationButtonStyle } from "../LayoutApp/LayoutApp.style";
import { IUserItemResponse } from "../../services/user-detail/user-detail.interface";
import { userActivityLogger } from "../../utils/mixpanel";
import { MIXPANEL_EVENTS } from "../../config/mixPanelEvents";

interface IHomeHospitalIndicator{
  isOpenSideBar: boolean;
  user?:IUserItemResponse;
}

const HomeHospitalIndicator = ({ isOpenSideBar, user }: IHomeHospitalIndicator) => {
  const [mapLocationUrl, setMapLocationUrl] = useState<string>("");

  useEffect(() => {
    if (user && user.location) {
      const googleMapUrl =
      "http://maps.google.com/maps?z=12&t=m&q=loc:"+user.location.position.lat+"+"+user.location.position.lng;

      setMapLocationUrl(googleMapUrl);
    }
  }, [user]);

  const googleMapRedirection = () => {
    userActivityLogger(MIXPANEL_EVENTS.USER_CLICK_HOSPITAL_NAVIGATION, {});
    window.open(mapLocationUrl, "_blank");
  };

  return (
    isOpenSideBar ? (
      <div
        className="w-full flex items-center justify-between bg-taupe-1 py-4 px-6 rounded cursor-pointer"
        onClick={googleMapRedirection}>
        <div className="flex gap-0.5 items-center">
          <ClinicLocationIcon width={30} height={30}/>

          <div className="flex flex-col items-start" >
            <div className="text-xs">
                Home Hospital
            </div>
            <div className="text-base font-semibold">
              {user?.location?.locationName}
            </div>
          </div>
        </div>

        <div><ClinicArrow width={30} height={30}/></div>
      </div>
    ) : (
      <Button
        id="locationButton"
        color="primary"
        size="small"
        sx={locationButtonStyle}
        onClick={googleMapRedirection}> <LocationPetIcon /> </Button>
    )
  );
};

export default HomeHospitalIndicator;
